module.exports = __webpack_public_path__ + "static/headshot-06d09f85883cba3ab68d4a8ba4adf281.jpg";